import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useLocation } from 'react-router'
import { fetchSession } from './api'
import { SESSION_STALE_TIME_MS, sessionQueryKey } from './session-context'

/**
 * 화면을 옮길 때 Session이 아직 살아 있는지 확인한다.
 *
 * 앱을 열 때와 창이 앞으로 나올 때는 확인 질의가 스스로 돈다. 남는 자리가 화면 이동이다. 창을
 * 앞에 켜 둔 채 오래 머무는 사람은 창이 뒤로 간 적이 없어 그 두 자리를 만나지 않고, 그 상태로
 * 쓰기 시작하면 첫 저장이 거절을 만나 쓴 것을 잃는다.
 *
 * 신선도를 그대로 따른다. 마지막 확인에서 얼마 지나지 않았으면 캐시된 판정을 쓰므로 화면을 여러
 * 번 옮겨도 요청이 그만큼 나가지 않는다.
 *
 * 화면을 막지 않는다. 확인이 돌아오기를 기다렸다 그리면 이동할 때마다 멈칫한다. 화면은 곧바로
 * 그리고 거절이 오면 그때 옮긴다. 옮기는 일은 이 자리가 아니라 확인 질의의 판정을 읽는 가드가
 * 맡는다.
 */
export function useSessionRefresh(): void {
  const queryClient = useQueryClient()
  const { pathname } = useLocation()

  useEffect(() => {
    void queryClient
      .ensureQueryData({
        queryKey: sessionQueryKey,
        queryFn: ({ signal }) => fetchSession(signal),
        staleTime: SESSION_STALE_TIME_MS,
      })
      .catch(() => {
        // 판정은 확인 질의가 쥐고 있다. 여기서 다시 다룰 것이 없다.
      })
  }, [queryClient, pathname])
}
